import { select, call, put, takeEvery, delay } from 'redux-saga/effects';
import {
  getUserProfiles,
  getUserProfilesSuccess,
  getUserProfilesFailure,
  deleteUserProfile,
  deleteUserProfileFailure,
} from '../../actions/ProfileList';
import { restoreLogin } from '../../actions/RestoreLogin';
import { checkActiveProfile } from '../../actions/CheckActiveProfile';

import { deleteProfileRequest } from '../../../api/requests/ProfileList/deleteProfile';
import { getUserProfilesRequest } from '../../../api/requests/GetUserProfiles/GetUserProfiles';

import { errorProcessing } from '../../../../Employees/api/errorProcessing';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};
const getUserId = state => {
  return (
    state.Authorization &&
    state.Authorization.user &&
    state.Authorization.user.id
  );
};
function* deleteProfileSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const userId = localStorage.user ? JSON.parse(localStorage.user).id : '';
      if (payload.addToUrl === activeProfileId) {
        localStorage.removeItem('activeProfile');
      }
      const response = yield call(deleteProfileRequest, payload);
      if (response.data.success) {
        yield put(checkActiveProfile());
        yield put(restoreLogin());
        yield delay(1000);
        yield put(getUserProfiles({ addToUrl: userId }));
      }
    } catch (e) {
      yield put(deleteUserProfileFailure(e));
    }
  } else {
    try {
      const { payload } = action;
      const userId = localStorage.user ? JSON.parse(localStorage.user).id : '';
      const response = yield call(deleteProfileRequest, payload);
      if (response.data.success) {
        yield put(checkActiveProfile());
        yield put(getUserProfiles({ addToUrl: userId }));
      }
    } catch (e) {
      yield put(deleteUserProfileFailure(errorProcessing(e)));
    }
  }
}

function* getUserProfilesSaga(action) {
  const userId = yield select(getUserId);
  if (userId) {
    try {
      yield delay(1000);
      const response = yield call(getUserProfilesRequest, userId);
      yield put(getUserProfilesSuccess(response));
    } catch (err) {
      yield put(getUserProfilesFailure(err));
    }
  }
}

export function* profileListWatcher() {
  //Запрашиваем профили пользователя
  yield takeEvery(getUserProfiles.toString(), getUserProfilesSaga);

  //Удалить профиль
  yield takeEvery(deleteUserProfile.toString(), deleteProfileSaga);
}
